/* eslint-disable import/prefer-default-export */
import loadable from '@loadable/component'

export const SustainableFitchIconTeaser = loadable(
  () => import('./SustainableFitchIconTeaser')
)
export const SustainableFitchIconTeaserGroup = loadable(
  () => import('./SustainableFitchIconTeaserGroup')
)

export type { SustainableFitchIconTeaserGroupProps } from './SustainableFitchIconTeaserGroup'
export type { SustainableFitchIconTeaserProps } from './SustainableFitchIconTeaser'
